/* eslint-disable import/no-anonymous-default-export */
import * as AmplifyAuth from "aws-amplify/auth";
import { PrivateKey } from "@hashgraph/sdk";
import {
  encryptMessage,
  establishSharedSecret,
  generateKeys,
  getErrorString,
  getUserDataFromCloud,
  uploadUserDataToCloud,
} from "constants/utils";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import {
  POST_CREATE_DID_REQUEST,
  POST_SUBMIT_DID_REQUEST,
  UPDATE_USER,
} from "services/ApiServices";

export default function () {
  const [generateDidResponse, setGenerateDidResponse] = useState({
    data: null,
    status: "idle",
  });
  const { t } = useTranslation();

  const generateDid = async ({ callBackOnSuccess = (...args: any) => {} }) => {
    if (generateDidResponse.status === "pending") {
      return;
    }
    const toastId = toast.loading(t("didGenInProgress"));
    try {
      setGenerateDidResponse({
        data: null,
        status: "pending",
      });

      const didPrivateKey = await PrivateKey.generateAsync();
      const keyPair = didPrivateKey.publicKey;

      const keyPairAsString = JSON.stringify({
        privateKey: didPrivateKey.toStringDer(),
        publicKey: didPrivateKey.publicKey.toStringDer(),
      });
      const publicKeyHex = keyPair.toStringDer();

      const createDidResponse = await POST_CREATE_DID_REQUEST({
        pubKey: publicKeyHex,
      });

      if (createDidResponse.status !== 200) {
        throw new Error("DID generation failed Response");
      }

      const { state, signingRequestBase64 } = createDidResponse.data.data;

      const sign = new Uint8Array(Buffer.from(signingRequestBase64, "base64"));
      const signature = didPrivateKey.sign(sign);

      const submitDidResponse = await POST_SUBMIT_DID_REQUEST({
        state,
        signedDIDRequest: Buffer.from(signature).toString("base64"),
      });

      if (submitDidResponse.status !== 200) {
        throw new Error("DID generation failed Sign Response");
      }

      const { did, didDocument } = submitDidResponse.data.data;

      // const asymmetricKeys = await getUserDataFromCloud({
      //   folderPath: "asymmetricKeys/keypair.txt",
      // });
      // const parseAsymmetricKeys =
      //   typeof asymmetricKeys === "string"
      //     ? JSON.parse(asymmetricKeys)
      //     : asymmetricKeys;

      // const sharedSecret = establishSharedSecret(
      //   isAsymmetricPubKey,
      //   parseAsymmetricKeys.privateKey
      // );
      // const encryptData = encryptMessage(sharedSecret, keyPairAsString);

      await uploadUserDataToCloud({
        data: keyPairAsString,
        folderPath: "userDid/keypair.txt",
      });

      // const response: any = await generateAysmetricKeypair();
      setGenerateDidResponse({
        data: null,
        status: "resolved",
      });
      toast.success(t("didGenSuccessful"));
      callBackOnSuccess({
        did: [{ did: did }],
        didDocument,
      });
      // You can return the DID Document or perform further actions here
      return {
        didDocument,
      };
    } catch (err) {
      toast.error(getErrorString(err));
      setGenerateDidResponse({
        data: null,
        status: "rejected",
      });
    } finally {
      toast.dismiss(toastId);
    }
  };

  const generateAysmetricKeypair = async () => {
    try {
      const keys = await generateKeys();
      await uploadUserDataToCloud({
        data: JSON.stringify(keys),
        folderPath: "asymmetricKeys/keypair.txt",
      });
      const authSes: any = await AmplifyAuth.fetchAuthSession();
      const formData = new FormData();
      formData.append("asymmetricPubKey", keys.publicKey);
      formData.append("identityId", authSes.identityId);
      const response = await UPDATE_USER(formData);
      return { response, keys };
    } catch (error: any) {
      throw new Error(error);
    }
  };

  return {
    generateDid,
    generateAysmetricKeypair,
  };
}
